@if (inlet.type !== 'null') {
<div class="inlet_block">
  @for (input of tree.getOpComponentInputs(opid, inletid); track input; let i = $index) {
  <div>
    <!-- {{input}} -->
    <div id="inlet{{opid}}-{{inletid}}-{{i}}" class="inlet_connector">
      <button mat-raised-button [disabled]="true" class="has_connection" [matTooltip]='inlet.dx'>

        {{inlet_name}}

        @if (inlet.type === 'notation') {
        <span class="dynamic_" class="inlet-label"> {{opnode.inlets[inletid]}}</span>
        }

        @if (inlet.type === 'profile') {
        <span class="inlet-label"> {{opnode.inlets[inletid]}}</span>

        }

        @if (inlet.type === 'color') {
        <div class="colorgroup">
          <div [matTooltip]="fc.value" [style.background-color]=fc.value class="input-color"></div>
        </div>
        }
      </button>
    </div>
  </div>
  }

  @if (inlet.num_drafts == -1 || (tree.getInputsAtNdx(opid, inletid).length < inlet.num_drafts)) { <button
    class="open_inlet" id="inlet{{opid}}-{{inletid}}-{{tree.getInputsAtNdx(opid, inletid).length}}" mat-raised-button
    [matTooltip]='inlet.dx' (click)="inputSelected()">

    <i class="fa-sharp fa-solid fa-circle-down"></i>
    {{inlet_name}}

    @if (inlet.type === 'notation') {
    <span class="dynamic_" class="inlet-label"> {{opnode.inlets[inletid]}}</span>
    }
    @if (inlet.type === 'profile') {
    <span class="inlet-label"> {{opnode.inlets[inletid]}}</span>
    }
    @if (inlet.type === 'color') {
    <div class="colorgroup">
      <div [matTooltip]="fc.value" [style.background-color]=fc.value class="input-color"></div>
    </div>
    }
    </button>

    }
</div>
}